import React, {useState} from "react";
import "./News.scss"
import New1 from "./imgs/2017-22-hn.png"
import New2 from "./imgs/2018-sh.png"
import New3 from "./imgs/2018-23-hn.png"
import New4 from "./imgs/2019-db.png"
import New5 from "./imgs/2019-sh.jpg"
import New6 from "./imgs/2019-24-hn.jpg"
import New8 from "./imgs/2020-gz.jpg"
import New9 from "./imgs/2020-sh.jpg"
import New10 from "./imgs/2021-zz.jpg"
import New11 from "./imgs/2021-sy.jpg"
import New13 from "./imgs/2021-cd.jpg"
import New14 from "./imgs/2021gz.jpg"
import New15 from "./imgs/2021-cc.jpg"
import New16 from "./imgs/2021qd.jpg"
import New17 from "./imgs/2021sjz.jpg"
import New18 from "./imgs/2021sh.jpg"
import New19 from "./imgs/2021km.jpg"
import New20 from "./imgs/2022-gz.jpg"
import Notice1 from "./imgs/notice1.png"
import Notice41 from "./imgs/news41.jpg"
import icon1 from "./imgs/new1.png"
import icon42 from"./imgs/news42.jpg"
import icon43 from"./imgs/43news.jpg"
import icon44 from"./imgs/2021sjz.jpg"
import icon45 from "./imgs/2021sh.jpg"
import icon46 from "./imgs/2021km.jpg"
import icon47 from "./imgs/news47.jpg"
import icon48 from "./imgs/news48.jpg"
import icon49 from "./imgs/news49.jpg"
import icon50 from"./imgs/news50.jpg"
import icon51 from"./imgs/icon51.jpg"

import {useFixedHeader} from "../../utils/headerHelper";
import {SubmitInfo} from "../../components/SubmitInfo/SubmitInfo";
import {BlackModal} from "../../components/BlackModal/BlackModal";
import {FooterFixed} from "../../components/FooterFixed";
import {ImgModal} from "./components/ImgModal/ImgModal";
import {CONFERENCE_DETAIL} from "./constants";
import intl from "react-intl-universal";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../locales/config";

export function News() {
    const lang = LOCALES_HELPER.getLan();

    useFixedHeader();

    const [imgSrc, setImgSrc] = useState(null);
    const [desc, setDesc] = useState("");

    function handleSetModal(img, desc) {
        setImgSrc(img);
        setDesc(desc);
    }

    return (
        <>
            <main className="news-content main-content">
                <header
                    className="page-header large image-background news-header-bg dark-color center no-padding"
                    data-stellar-background-ratio="0.3">
                    <div className="container v-align-center">
                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="x-large">{intl.get('zh&xw')}</h1>
                                <div>
                                    <i className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                    className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                    className="icon-glyph-10 medium"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                {/*<BannerNews/>*/}

                <section className="pt-medium pb-medium light-color">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-medium text-center heading primary-color">
                                <h1>
                                    <span>{lang === DEFAULT_LOCALE ? "Exhibitions over the years" : ""}</span>{intl.get('lnzh')}
                                </h1>

                            </div>
                        </div>
                        <div className="row">
                            <section className="col-md-12">
                                <div className="row cus-mews-wrapper">




                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex20')}>
                                                <img src={New20} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New20, CONFERENCE_DETAIL.HUANAN_DESC2022)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex20')}
                                                    </h3>
                                                    <small>{intl.get('ex20-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex19')}>
                                                <img src={New19} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New19, CONFERENCE_DETAIL.KMCHINA_DESC2021)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex19')}
                                                    </h3>
                                                    <small>{intl.get('ex19-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex18')}>
                                                <img src={New18} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New18, CONFERENCE_DETAIL.SHCHINA_DESC21)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex18')}
                                                    </h3>
                                                    <small>{intl.get('ex18-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex17')}>
                                                <img src={New17} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New17, CONFERENCE_DETAIL.SJZCHINA_DESC21)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex17')}
                                                    </h3>
                                                    <small>{intl.get('ex17-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex16')}>
                                                <img src={New16} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New16, CONFERENCE_DETAIL.QDZCHINV_DESC21)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex16')}
                                                    </h3>
                                                    <small>{intl.get('ex16-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex15')}>
                                                <img src={New15} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New15, CONFERENCE_DETAIL.CCZCHINV_DESC21)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex15')}
                                                    </h3>
                                                    <small>{intl.get('ex15-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex14')}>
                                                <img src={New14} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New14, CONFERENCE_DETAIL.HUANAN_DESC21)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex14')}
                                                    </h3>
                                                    <small>{intl.get('ex14-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex13')}>
                                                <img src={New13} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New13, CONFERENCE_DETAIL.CDZCHINV_DESC21)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex13')}
                                                    </h3>
                                                    <small>{intl.get('ex13-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex11')}>
                                                <img src={New11} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New11, CONFERENCE_DETAIL.SYZCHINV_DESC21)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex11')}
                                                    </h3>
                                                    <small>{intl.get('ex11-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex10')}>
                                                <img src={New10} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New10, CONFERENCE_DETAIL.ZZZCHINV_DESC21)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex10')}
                                                    </h3>
                                                    <small>{intl.get('ex10-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex9')}>
                                                <img src={New9} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New9, CONFERENCE_DETAIL.SHCHINV_DESC20)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex9')}
                                                    </h3>
                                                    <small>{intl.get('ex9-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex8')}>
                                                <img src={New8} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New8, CONFERENCE_DETAIL.HUANAN_DESC20)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex8')}
                                                    </h3>
                                                    <small>{intl.get('ex8-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="400">
                                        <article className="team-box no-padding">
                                            <figure title={intl.get('ex6')}>
                                                <img src={New6} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New6, CONFERENCE_DETAIL.HUANAN_DESC)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex6')}
                                                    </h3>
                                                    <small>{intl.get('ex6-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="400">
                                        <article className="team-box no-padding">
                                            <figure title={intl.get('ex5')}>
                                                <img src={New5} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New5, CONFERENCE_DETAIL.CHINA_DESC)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex5')}
                                                    </h3>
                                                    <small>{intl.get('ex5-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="400">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex4')}>
                                                <img src={New4} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New4, CONFERENCE_DETAIL.DIBAI_DESC)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex4')}
                                                    </h3>
                                                    <small>{intl.get('ex4-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="300">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex3')}>
                                                <img src={New3} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New3, CONFERENCE_DETAIL.HUANAN_DESC)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">
                                                        {intl.get('ex3')}
                                                    </h3>
                                                    <small>{intl.get('ex3-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="200">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex2')}>
                                                <img src={New2} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New2, CONFERENCE_DETAIL.CHINA_DESC)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">{intl.get('ex2')}</h3>
                                                    <small>{intl.get('ex2-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>

                                    <div className="col-sm-4" data-nekoanim="fadeIn" data-nekodelay="100">
                                        <article className="team-box no-padding mb">
                                            <figure title={intl.get('ex1')}>
                                                <img src={New1} alt="image" data-toggle="modal" data-target="#myModal"
                                                     onClick={() => handleSetModal(New1, CONFERENCE_DETAIL.HUANAN_DESC)}
                                                     className="responsive"/>
                                                <figcaption className="text-center box light-color">
                                                    <h3 className="text-ellipse">{intl.get('ex1')}</h3>
                                                    <small>{intl.get('ex1-t')}</small>
                                                </figcaption>
                                            </figure>
                                        </article>
                                    </div>


                                </div>
                            </section>
                            <ImgModal src={imgSrc} desc={desc}/>
                        </div>
                    </div>
                </section>

                <section className="light-color">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-medium text-center heading primary-color">
                                <h1><span>{lang === DEFAULT_LOCALE ? "Industry News" : ""}</span>{intl.get('hyxw')}</h1>
                            </div>
                        </div>
                    </div>
                </section>



                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon51} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news51-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news51-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/51.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time"> 2022-03-20 15:15</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon50} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news50-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news50-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/50.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time"> 2022-02-26 12:00</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon49} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news49-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news49-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/49.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time"> 2022-02-08 09:05</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon48} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news48-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news48-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/48.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time"> 2022-01-01 08:00</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon47} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news47-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news47-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/47.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time"> 2021-12-02 18:21</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon46} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news46-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news46-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/46.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time"> 2021-11-28 12:00</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon45} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news45-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news45-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/45.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time">2021-11-05 16:13</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon44} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news44-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news44-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/44.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time">2021-10-12 23:22</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon43} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news43-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news43-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/43.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time">2021-09-19 12:36</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon42} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news42-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news42-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/42.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time">2021-08-06 18:01</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={Notice41} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('notice41-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('notice41-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/notice/41.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time">2021-08-04 08:16</span>
                            </div>
                        </div>

                    </div>
                </section>




                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={Notice1} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('notice1-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('notice1-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/notice/1.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time">2021/09/13 12:30</span>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                    <div className="container">
                        <div className="box news-box">
                            <div className="news-wrapper">
                                <div className="news-img">
                                    <img src={icon1} className="img-responsive mb-sm" alt=""/>
                                </div>
                                <div className="new-content">
                                    <div className="new-title-wrapper">
                                        <span className="news-title">{intl.get('news1-title')}</span>
                                    </div>
                                    <p className="p-of-3">
                                        {intl.get('news1-desc')}
                                    </p>
                                    <a href={`thirdpart/pdf/web/viewer.html?file=/thirdpart/pdf/news/1.pdf`}
                                       target="_blank" className="btn default small border">{intl.get('see-more')}</a>
                                </div>
                                <span className="news-time">2021/03/20 18:16</span>
                            </div>
                        </div>

                    </div>
                </section>




                <SubmitInfo/>
                <BlackModal/>
            </main>
            <FooterFixed/>
        </>
    )
}
